export function replaceNewLineWithTag(text = "") {
  if (!text) return "";
  return text.replace(/\n/g, "<br />");
}
